import { lazy } from 'react'

const DashboardAnalytics = lazy(() => import('../../views/dashboard/tv'))
const DashboardEcommerce = lazy(() => import('../../views/dashboard/ecommerce'))
const Dashboard = lazy(() => import('../../views/dashboard'))

const DashboardRoutes = [
  {
    path: '/dashboard/analytics',
    element: <DashboardAnalytics />
  },
  {
    path: '/dashboard/ecommerce',
    element: <DashboardEcommerce />
  },
  {
    path: '/dashboard',
    // element: <DashboardFF /> 
    element: <Dashboard />
  }
]

export default DashboardRoutes
